import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ModuloService {

    constructor(private apiService: ApiService,
        private httpClient: HttpClient
    ) { }


    insertarModulo(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.modulos_insertar_url);
        return this.apiService.executePostJson(data).pipe();
    }

    obtenerModulos(activo: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.modulos_buscar);
        return this.apiService.execGetQueryJson(`soloActivos=${activo}`)
    }
    getModulos(id_cia: any) {
        this.apiService.setUrlPathApi(`company/${id_cia}/modulos`);
        return this.apiService.execGetJson();
    }

    listarUsuarios(codmod: any, activo?: any) {
        this.apiService.setUrlPathApi(`usuario/modulos/buscar/usuarios`);

        let params = `?codmod=${codmod}`;
        if (activo !== undefined && activo !== null && activo !== '') {
            params += `&activo=${activo}`;
        }

        return this.apiService.execGetQueryJson(params);
    }
    
    obtener(codmod: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.modulos_obtener);
        return this.apiService.execGetQueryJson(`${codmod}`)
    }

    actualizar(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.modulos_actualizar);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminar(codmod: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.modulos_eliminar);
        return this.apiService.executeDeleteJson(`${codmod}`);
    }
    /*
    eliminar(codmod: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.modulos_eliminar);
        return this.apiService.executeDeleteJson(codmod).pipe();
    }
    */
   

    deleteUserModulesMasivo(codigo: any, body: { usuarios: string }): Observable<any> {
        return this.httpClient.put(`${environment.serviceUrl}usuario/modulos/${codigo}`, body);
    }

    postUserModulesMasivo(codigo: any, body: { usuarios: string }): Observable<any> {
        return this.httpClient.post(`${environment.serviceUrl}usuario/modulos/${codigo}`, body);
    }
} 